export default "__VITE_ASSET__d1c63cdf__"